module.exports = __webpack_public_path__ + "img/25.5de7563c.jpg";